import React from 'react';
import { Box, Svg, Text } from '@hopskipdrive/react-components';

import { Container } from './styles';

const NotFound: React.FC = () => {
  return (
    <Container>
      <Box display="flex" alignItems="flex-start" flexDirection="column" gap="26px">
        <Svg icon="hsd-logo" width={104} height={93} alt="HopSkipDrive logo" />
        <Box display="flex">
          <Text variant="h5" textColor="primaryText" fontWeight={600} mr={4}>
            Error 404.
          </Text>
          <Text variant="h5" textColor="secondaryText" fontWeight={600}>
            Cannot find the page
          </Text>
        </Box>
        <Text variant="body2" textColor="secondaryText" fontWeight={400}>
          The page you are trying to open is not available.
        </Text>
      </Box>
    </Container>
  );
};

export default NotFound;
